// getCookie('favorite_job_ids') の結果を整数の求人 ID 配列にそろえる（配列でなければ空配列、整数以外の要素は除外）
export function normalizeFavoriteJobIds(value) {
  return Array.isArray(value) ? value.filter((id) => Number.isInteger(id)) : [];
}
